<template>
  <!-- 请假规则 -->
  <div class="holiday-rule">
    <h3>
      <span>{{ $t('765') }}</span>
      <el-button
        plain
        class="create-rule"
        type="primary"
        @click="addOrUpdateFn(null)"
        v-if="$p('menu.work.rule.edit')"
        >{{ $t('132') }}</el-button
      >
    </h3>
    <el-table ref="table" style="margin: 20px 0" :data="page.list" :height="tableHeight" :loading-text="$t('989')">
      <el-table-column prop="name" :label="$t('104')" align="center" fixed="left" :key="1">
        <template slot-scope="scope">
          {{ scope.row.name }}
          <el-tag type="danger" v-if="scope.row.status === '2'">{{ $t('1355') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('136')" align="center" :key="2">
        <template slot-scope="scope">
          <span v-if="scope.row.is_setting === '0'">{{ $t('917') }}</span>
          <span v-if="scope.row.is_setting === '1'">
            {{ $t('918') }}
          </span>
        </template>
      </el-table-column>
      <!-- 使用范围（人） -->
      <el-table-column prop="num" :label="$t('1601')" align="center" :key="3"></el-table-column>
      <!-- 计薪规则 -->
      <el-table-column prop="is_paid_text" :label="$t('1151')" align="center" :key="4"></el-table-column>
      <!-- 备注 -->
      <el-table-column prop="mark" :label="$t('1602')" align="center" :key="5"></el-table-column>
      <!-- 操作 -->
      <el-table-column :label="$t('70')" width="400" align="center" :key="6">
        <template slot-scope="scope">
          <el-button type="primary" @click="addOrUpdateFn(scope.row)" plain v-if="$p('menu.work.rule.edit')">
            {{ $t('71') }}
          </el-button>
          <el-button type="danger" @click="ruleFn(scope.row, 3)" plain v-if="$p('menu.work.rule.delete')">
            {{ $t('65') }}
          </el-button>
          <el-button
            @click="ruleFn(scope.row, 1)"
            v-if="scope.row.status === '2' && $p('menu.work.rule.delete')"
            type="primary"
            plain
          >
            {{ $t('137') }}
          </el-button>
          <el-button
            @click="ruleFn(scope.row, 2)"
            v-if="scope.row.status === '1' && $p('menu.work.rule.delete')"
            type="danger"
            plain
          >
            {{ $t('139') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-wrap">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        :page-sizes="pageSizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :total="page.total"
        :current-page="page.currPage"
        :page-size="page.limit"
      >
      </el-pagination>
    </div>
    <add-or-update v-if="isAddOrUpdate" ref="addOrUpdate" @getTableList="getTableList"> </add-or-update>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import addOrUpdate from './add-or-update'
import { ruleListFn, ruleFn } from 'api/approval/config'
export default {
  components: {
    addOrUpdate
  },
  data() {
    return {
      pageSizes: [100, 50, 20],
      page: {
        list: [],
        currPage: 1,
        limit: 20,
        total: 0
      },
      isAddOrUpdate: false
    }
  },
  computed: {
    ...mapState({
      contentViewHeight: state => state.settings.contentViewHeight
    }),
    tableHeight() {
      return this.contentViewHeight - 260
    }
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    async getTableList() {
      const res = await ruleListFn({
        page: this.page.currPage,
        size: this.page.limit
      })
      this.$emit('clear-loading')
      if (res && res.code === 1) {
        this.page.list = res.data.result
        this.page.total = res.data.count
        this.$nextTick(() => {
          if (this.$refs.table) {
            this.$refs.table.doLayout && this.$refs.table.doLayout()
          }
        })
      }
    },
    // 每页条数
    sizeChangeHandle(val) {
      this.page.limit = val
      this.getTableList()
    },
    // 切换 页
    currentChangeHandle(val) {
      this.page.currPage = val
      this.getTableList()
    },
    addOrUpdateFn(item) {
      this.isAddOrUpdate = true
      this.$nextTick(() => this.$refs.addOrUpdate.init(item))
    },
    ruleFn(item, type) {
      // 1619 是否确认删除该假期
      // 1620 是否确认停用该假期
      // 1621 是否确认启用该假期
      const warnArr = new Map([
        [3, this.$t('1619')],
        [2, this.$t('1620')],
        [1, this.$t('1621')]
      ])
      this.$confirm(warnArr.get(type), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(() => {
        ruleFn({ id: item.id, type }).then(res => {
          if (res && res.code === 1) {
            this.getTableList()
            this.$message.success(res.message)
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.create-rule {
  float: right;
  transform: translateY(-8px);
}
/deep/ .el-table {
  margin-top: 40px !important;
  /deep/ .el-button {
    background: transparent;
    border: 0;
    &:hover {
      background: transparent;
      color: rgba($theme, 0.8);
    }
    &:active {
      background: transparent;
      color: rgba($theme, 0.9);
    }
    &:focus {
      background: transparent;
      color: rgba($theme, 0.9);
    }
  }
  /deep/ .el-button--danger {
    &:hover {
      color: rgba(red, 0.8);
    }
    &:active {
      background: transparent;
      color: rgba(red, 0.9);
    }
    &:focus {
      background: transparent;
      color: rgba(red, 0.9);
    }
  }
}
</style>
